const INBOUND_BASE_URL = process.env.REACT_APP_INBOUND_API_BASE_URL;
const API_USERS = `${INBOUND_BASE_URL}/master/users`;
const API_GET_DOWNLOAD_USERS = `${API_USERS}/download`;
const API_RESET_PASSWORD = `${INBOUND_BASE_URL}/master/users/reset`;

export { API_USERS, API_RESET_PASSWORD, API_GET_DOWNLOAD_USERS };
